module.exports = __webpack_public_path__ + "static/media/bloodThinner.6c6a68d0.mp3";